import React, { useState } from "react";
import { Header } from "../Header";
import { Layout } from "./Layout";
import { Sidebar } from "../Sidebar";

export const Stakebutton = () => {
  const [isSidebar, setSidebar] = useState(false);
  return (
    <>
      {isSidebar && <Sidebar />}
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
      >
        <div className="marquee">
          <marquee>
            Betfair exchange odds are under maintenance Bookmaker and Fancy odds
            are available to play.
          </marquee>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                <Layout />
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-stack-buttons
                    _nghost-dml-c165=""
                    className="ng-star-inserted"
                  >
                    <div _ngcontent-hdd-c162="" className="right-tab-box">
                      <div
                        _ngcontent-hdd-c162=""
                        id="v-pills-tabContent"
                        className="tab-content ng-star-inserted"
                      >
                        <div
                          _ngcontent-hdd-c162=""
                          id="v-pills-stack"
                          role="tabpanel"
                          aria-labelledby="v-pills-stack-tab"
                          className="tab-pane show active acc-stat-box"
                        >
                          <form
                            _ngcontent-hdd-c162=""
                            noValidate=""
                            className="p-4 ng-pristine ng-valid ng-touched"
                          >
                            <div
                              _ngcontent-hdd-c162=""
                              className="row justify-content-center"
                            >
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-1"
                                >
                                  Button 1
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake1"
                                  name="btn-1"
                                  id="Button-1"
                                  className="form-control "
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-2"
                                >
                                  Button 2
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake2"
                                  name="btn-2"
                                  id="Button-2"
                                  className="form-control ng-pristine ng-valid ng-touched"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-3"
                                >
                                  Button 3
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake3"
                                  name="btn-3"
                                  id="Button-3"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-4"
                                >
                                  Button 4
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake4"
                                  name="btn-4"
                                  id="Button-4"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-5"
                                >
                                  Button 5
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  formcontrolname="stake5"
                                  type="number"
                                  name="btn-5"
                                  id="Button-5"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-6"
                                >
                                  Button 6
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake6"
                                  name="btn-6"
                                  id="Button-6"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-7"
                                >
                                  Button 7
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  formcontrolname="stake7"
                                  type="number"
                                  name="btn-7"
                                  id="Button-7"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-3 input-box"
                              >
                                <label
                                  _ngcontent-hdd-c162=""
                                  htmlFor="Button-8"
                                >
                                  Button 8
                                </label>
                                <input
                                  _ngcontent-hdd-c162=""
                                  type="number"
                                  formcontrolname="stake8"
                                  name="btn-8"
                                  id="Button-8"
                                  className="form-control ng-untouched ng-pristine ng-valid"
                                  max="50000"
                                  min="100"
                                />
                              </div>
                              <div
                                _ngcontent-hdd-c162=""
                                className="col-md-12 btn-box col-sm-12 col-lg-2"
                              >
                                <button
                                  _ngcontent-hdd-c162=""
                                  type="submit"
                                  className="btn btn-info"
                                >
                                  {" "}
                                  updatestake{" "}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </app-stack-buttons>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};
